// Whether the meeting hides rooms (the `hideRooms` meeting global): when set, no session's room or
// venue is shown, exported or offered as a way to browse the program.
export function roomsHidden(site) {
    return Boolean(site?.meeting?.hideRooms)
}
